import { useContext } from 'react';

import { ListContext } from '@contexts/ListContext';
import { UserContext } from '@contexts/UserContext';

const useAccountingGroupDepartments = (NetworkAgencyID) => {
    const { cachedList } = useContext(ListContext);
    const { currentUser } = useContext(UserContext);

    const currentAccGroup = cachedList.accountingGroups.items.find(
        (ag) => ag.ID === currentUser.ActiveContext.accGroupId
    );

    const returnObject = { isSingleAgency: currentAccGroup.NetworkAgencies.length === 1, departments: [] };
    if (!NetworkAgencyID) {
        for (const networkAgency of currentAccGroup.NetworkAgencies) {
            for (const department of networkAgency.Departments) {
                returnObject.departments.push({
                    ...department,
                    networkAgencyId: networkAgency.ID,
                    networkAgencyName: networkAgency.Name,
                    accountingGroupId: currentAccGroup.ID,
                    accountingGroupName: currentAccGroup.Name,
                });
            }
        }
    } else {
        const currentNwAg = currentAccGroup.NetworkAgencies.find((nwAg) => nwAg.ID === NetworkAgencyID);
        for (const department of currentNwAg.Departments) {
            returnObject.departments.push({
                ...department,
                networkAgencyId: currentNwAg.ID,
                networkAgencyName: currentNwAg.Name,
                accountingGroupId: currentAccGroup.ID,
                accountingGroupName: currentAccGroup.Name,
            });
        }
    }
    return returnObject;
};

export default useAccountingGroupDepartments;
